<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script setup>
</script>

<style>
@import "./styles/common.scss";
</style>
